// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar-background[data-v-1a0d17c7],.avatar-image[data-v-1a0d17c7]{width:80px;height:80px;border-radius:50%;border:1px solid #c6c6c6}.avatar-background[data-v-1a0d17c7]{display:inline-block;background-repeat:no-repeat;background-size:cover;background-position:50%}.spinner-border[data-v-1a0d17c7]{position:absolute;left:-7px;top:-21px;right:0;bottom:0;margin:auto}", ""]);
// Exports
module.exports = exports;
